import React from "react";

import classes from "./MessageDetails.module.css";
import { ConstUserGroupEnum } from "../../../../../models/ConstUserGroupEnum";
import { useSelector } from "react-redux";
import { RadioInput, RadioOption } from "../../../../UI/Inputs/InputRadio/RadioBtns";
import CheckBox from "../../../../UI/CheckBox";
import InputCharLimit from "../../../../UI/Inputs/InputCharLimit/InputCharLimit";
import BtnSelect from "../../../../UI/Buttons/BtnSelect";
import ScrollLTR from "../../../../lms-shared/UI/ScrollLTR";
import moment from "moment";

const MessageDetails = ({ inputs, iconList, saveMessage, handleChangeInput, setSelectCourses, selectCourses, disciplines, setSelectIcon }) => {
    const { texts } = useSelector(state => state.translate);

    const handelChangeDate = (expireDate) => {
        let view = 1
        if (new Date(expireDate) < new Date())
            view = 0
        handleChangeInput("view", view)
        handleChangeInput("expireDate", expireDate)
        handleChangeInput("expireDateFlag", 1)
    }


    return <>
        <div className={classes.Part}>
            <div className={classes.PartTitle}>{texts.target} :</div>
            <div className={`${classes.WrapTarget} ${classes.DisableTarget}`}>
                {inputs.id && <div className={classes.Disable}></div>}
                <div>
                    <label>{texts.targetMessage}</label>
                    <div className={classes.Margin}>
                        <RadioInput name={"targetObjectId"} onChangeValue={handleChangeInput} value={inputs.targetObjectId} >
                            <RadioOption value={ConstUserGroupEnum.All}>{texts.all}</RadioOption>
                            <RadioOption value={ConstUserGroupEnum.Student}>{texts.students}</RadioOption>
                            <RadioOption value={ConstUserGroupEnum.Teacher}>{texts.teachers}</RadioOption>
                        </RadioInput>
                    </div>
                </div>
                <div className={classes.Line}></div>
                {inputs.targetObjectId === ConstUserGroupEnum.Student && disciplines &&
                    <div>
                        <label>{texts.subjectsMessages}</label>
                        <ScrollLTR dropStyle={{ height: "150px", width: "305px", marginTop: "5px" }}>
                            <div className={classes.Scroll}>
                                <CheckBox key={"all"}
                                    checked={selectCourses.length === disciplines.length}
                                    value={"all"}
                                    onChecked={(value) => { setSelectCourses(disciplines.map(c => c.id)) }}
                                    onRemoveChecked={(value) => { setSelectCourses([]) }}
                                >{texts.all}
                                </CheckBox>
                                <div className={classes.CheckBoxesWrap}>
                                    {disciplines.map(c => <div className={classes.CheckBoxWrap} key={c.id}> <CheckBox
                                        checked={selectCourses.includes(c.id)}
                                        value={c.id}
                                        onChecked={(value) => { setSelectCourses(pre => [...pre, value]) }}
                                        onRemoveChecked={(value) => {
                                            setSelectCourses(pre => pre.filter(c => c != value))
                                        }}
                                    > {c.name}</CheckBox></div>)}
                                </div>
                            </div>
                        </ScrollLTR>
                    </div>}
            </div>
        </div>
        <div className={classes.Part}>
            <div className={classes.PartTitle}>{texts.designNewMessage} :</div>
            <div className={classes.WrapContent}>
                <div className={classes.SelectIcon} style={{ backgroundImage: `url(${inputs.messageType?.icon})` }} onClick={() => setSelectIcon(true)} >{!inputs.messageType?.id && `+ ${texts.selectIcon}`} </div>
                {<div className={classes.WrapInputs}>
                    <InputCharLimit label={texts.he} limitNum={120} name={"textHe"} setValue={handleChangeInput} value={inputs.textHe} type="textarea" style={{ border: "1px solid black", width: "387px", height: "50px" }} ></InputCharLimit>
                    <InputCharLimit label={texts.ar} limitNum={120} name={"textAr"} setValue={handleChangeInput} value={inputs.textAr} type="textarea" style={{ border: "1px solid black", width: "387px", height: "50px" }}></InputCharLimit>
                    <InputCharLimit label={texts.en} limitNum={120} name={"textEn"} setValue={handleChangeInput} value={inputs.textEn} type="textarea" style={{ border: "1px solid black", width: "387px", height: "50px" }}></InputCharLimit>
                </div>}
            </div>
        </div>
        <div className={classes.Part}>
            <div className={classes.PartTitle}>{texts.linkInput} :</div>
            <input className={classes.InputLink} value={inputs.link} type={'text'} onChange={(e) => handleChangeInput("link", e.target.value)} ></input>
        </div>
        <div className={`${classes.Part} ${classes.WrapViewDate}`}>
            <div>
                <div className={classes.PartTitle}>{texts.view} :</div>
                <RadioInput name={"view"} onChangeValue={handleChangeInput} value={inputs.view}>
                    <RadioOption value={1}>{texts.show}</RadioOption>
                    <RadioOption value={0}>{texts.hidden}</RadioOption>
                </RadioInput>
            </div>
            <div>
                <div className={classes.PartTitle}>{texts.expireDate} :</div>
                <RadioInput name={"expireDateFlag"} onChangeValue={handleChangeInput} value={inputs.expireDateFlag}>
                    <RadioOption value={0}>{texts.no}</RadioOption>
                    <RadioOption value={1}>{texts.removeDate}</RadioOption>
                </RadioInput>
                {inputs.expireDateFlag && <input className={classes.InputDate} type={'date'} value={moment(inputs.expireDate?inputs.expireDate:new Date()).format("YYYY-MM-DD")} name={"expireDateFlag"} onChange={(e) => handelChangeDate(e.target.value)}></input>}
            </div>
        </div>
        <div className={classes.Send}><BtnSelect checked={true} onClick={saveMessage} dropStyle={{ width: "114px", height: "30px" }}>{texts.send}</BtnSelect></div>
    </>
}

export default MessageDetails;